export default {
	apis: process.env.REACT_APP_API_ENDPOINT,
	login: process.env.REACT_APP_LOGIN_URL,
	logout: process.env.REACT_APP_LOGOUT_URL,
	token: process.env.REACT_APP_TOKEN_URL,
	refreshToken: process.env.REACT_APP_REFRESH_TOKEN_URL,
	logoutProvider: process.env.REACT_APP_LOGOUT_PROVIDER
};
